<template>
  <router-view />
</template>

<script>
export default {
  name: 'UmsTenantsWrapper',
};
</script>
